import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getRoles = ({ id, forFilter }: { id?: number, forFilter?: boolean }) => {

  const queryParams = id ?
    { user_id: id }
    :
    forFilter ?
      { for_filter: true }
      :
      {};

  return axiosPrivate.get(`/dashboard/v1/roles/role_list`, { params: { ...queryParams } });
};